import React, { Component } from "react";

import { Formik } from "formik";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import Spinner from "../../atoms/Spinner";
import DateField from "../DateField";
import { TextField } from "@material-ui/core";
import Numberformat from "../../atoms/Numberformat/index";
import Dialog from "./Dialog";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const styles = theme => ({
  legend: {
    color: "grey",
    fontSize: "small"
  },
  error: {
    color: "red"
  }
});

const isDateSupported = () => {
  if (document) {
    var i = document.createElement("input");
    i.setAttribute("type", "date");
    return i.type !== "text";
  } else {
    return false;
  }
};

class PayForm extends Component {
  renderAllErrorMsgs(errors) {
    const listErrors = errors => {
      let elist = [];
      Object.keys(errors).forEach((key, index) => {
        elist.push(
          <Typography key={index} style={{ color: "red" }} gutterBottom>
            {errors[key]}
          </Typography>
        );
      });
      return elist;
    };

    return (
      <Grid container spacing={10}>
        <Grid item>{listErrors(errors)}</Grid>
      </Grid>
    );
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.pay.saving_success) {
      toast("Payment for order " + this.props.order.OrderNumber + " saved!");

      this.props.onClose();
    }
  }
  render() {
    const { classes } = this.props;
    const now = new Date();
    return (
      <Dialog open={this.props.open} onClose={this.props.onClose}>
        <Grid container spacing={10}>
          <Grid item xs={12} sm={12}>
            <Typography variant="h4" gutterBottom>
              Order: {this.props.order.OrderNumber} - {this.props.order.Email}
            </Typography>
            {/* <Typography>
                <small>{this.props.order.OrderID}</small>
              </Typography> */}
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography className={classes.legend}>Date of order</Typography>
            <Typography>
              {new Date(this.props.order.OrderDate).toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography className={classes.legend}>Amount</Typography>
            <Typography>
              <Numberformat
                value={this.props.order.sum}
                digits={this.props.order.currency === "EUR" ? 2 : 6}
              />
              &nbsp;{this.props.order.currency}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography className={classes.legend}>Token</Typography>
            <Typography>
              <Numberformat value={this.props.order.token} digits={6} />
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize={true}
          initialValues={{
            paydate: now.toISOString().substr(0, 10),
            sum: this.props.order.sum,
            token: this.props.order.token,
            OrderNumber: this.props.order.OrderNumber,
            OrderID: this.props.order.OrderID,
            Email: this.props.order.Email
          }}
          onSubmit={(values, actions) => {
            this.props.savePayment({ ...values });

            // this.props.save({
            //   section: "investment",
            //   data: {
            //     ...values.investment,
            //     Status: "created"
            //   }
            // });

            actions.setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            // investment: Yup.mixed().test(
            //   "min",
            //   "You need to buy a minimum of " + min_token + " token.",
            //   value => value.token >= min_token
            // )
          })}
          render={props => (
            <form
              onSubmit={props.handleSubmit}
              className={classes.container}
              name="PayForm"
            >
              <Grid container spacing={10}>
                <Grid item xs={12} sm={12}>
                  <Typography>
                    Enter date of payment and correct Values if needed
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DateField
                    type="date"
                    name="paydate"
                    label={isDateSupported() ? " " : "Date of payment"}
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.paydate}
                    min={this.props.order.OrderDate}
                    max={now}
                    onBlur={props.handleBlur}
                    error={typeof props.errors.paydate !== "undefined"}
                    helperText={
                      props.errors.paydate && props.touched.paydate
                        ? props.errors.paydate
                        : "Date of Payment" +
                          (isDateSupported() ? "" : " (YYYY-MM-DD)")
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    type="number"
                    name="sum"
                    label={"Amount " + this.props.order.currency}
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.sum}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.sum !== "undefined"}
                    helperText={
                      props.errors.sum && props.touched.sum
                        ? props.errors.sum
                        : ""
                    }
                    // InputProps={{
                    //     endAdornment: <InputAdornment position="end">{this.props.order.currency}</InputAdornment>,
                    //   }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    type="number"
                    name="token"
                    label="Token"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.token}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.token !== "undefined"}
                    helperText={
                      props.errors.token && props.touched.token
                        ? props.errors.token
                        : ""
                    }
                  />
                </Grid>
              </Grid>
              {this.renderAllErrorMsgs(props.errors)}
              <div className={classes.actionsContainer}>
                {this.props.pay.saving && (
                  <Spinner className={classes.spinner} />
                )}
                {!this.props.pay.saving && (
                  <Button
                    type="submit"
                    name="submit"
                    color="primary"
                    variant="outlined"
                    className={classes.button}
                    id="btnMarkOrderAsPaidSaveDetails"
                  >
                    Save
                  </Button>
                )}
                {this.props.pay.saving_error !== null && (
                  <Typography className={classes.error}>
                    Saving failed! Please try again.
                  </Typography>
                )}
              </div>
            </form>
          )}
        />
      </Dialog>
    );
  }
}

export default withStyles(styles)(PayForm);
